import React from 'react'
import MetaWrapper from '@components/Meta/MetaWrapper'
import Page from './Page'
import { useFlatPageQuery } from '@graphql/queries/__generated__/flatpage.generated'
import { WHOLESALE_ROUTES } from '../../../urls'
import { useTranslation } from 'react-i18next'

const View: React.FC = () => {
  const { t } = useTranslation()
  const { data, loading } = useFlatPageQuery({
    variables: {
      url: WHOLESALE_ROUTES.TERMS,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })
  return (
    <MetaWrapper titleDetails={t('metaTitle.wholesaleTerms', 'Wholesale Terms')}>
      <Page page={data?.flatpage} isLoading={loading} />
    </MetaWrapper>
  )
}

export default View
